import {z} from 'zod'

import {CreateOrUpdateBlockDividerDocument} from '@sdox/api'

import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'

import type {CreateOrUpdateBlockDividerMutation} from '@sdox/api'

type CreateDividerValidatorSchema = z.infer<typeof createDividerValidatorSchema>

const createDividerValidatorSchema = z.object({
  meta: createMetaSchema,
  data: z.object({}),
})

export const dividerConfig = createFormConfig<CreateDividerValidatorSchema, CreateOrUpdateBlockDividerMutation, never>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockDividerDocument,
  },
  validatorSchema: createDividerValidatorSchema,
  getDefaultValues: () => {
    return {
      data: {},
    }
  },
})
